import Icon from './atomic/Icon'
import React from 'react'
import Trans from './atomic/Trans'
import { scrollToRef } from '../utils'

const AutoreSummary = React.memo(
  React.forwardRef((props, ref) => {
    const { autore, articoli, strumenti, raccolte } = props

    const thumb = autore.avatar ? autore.avatar : null
    const classi = 'autore-summary' + (autore.redazionale ? ' autore-summary--redazionale' : '')

    return (
      <div className={classi}>
        <div className="autore-summary__main">
          <div className="autore-summary__image-box">
            {thumb ? (
              <img
                src={thumb}
                alt={autore.titolo?.toAltTitle()}
                title={autore.titolo?.toAltTitle()}
                className="autore-summary__image"
              />
            ) : (
              <Icon id="user" />
            )}
          </div>
          <div className="autore-summary__content">
            <p className="autore-summary__fullname">
              {autore.titolo}{' '}
              {autore.redazionale && <Icon id="logosymbol" classes="icon--logosymbol" />}
            </p>
            {!autore.redazionale ? (
              <div className="autore-summary__community">
                <Icon id="community" classes="icon--community"></Icon>
                <span>Dalla community</span>
              </div>
            ) : autore.headline ? (
              <p className="autore-summary__type">{autore.headline}</p>
            ) : null}
            {autore.redazionale && (
              <>
                {articoli.length || strumenti.length || raccolte.length ? (
                  <div className="autore-summary__links">
                    {articoli.length ? (
                      <button
                        type="button"
                        className="autore-summary__link"
                        onClick={() => scrollToRef(ref.articoliSlider)}
                      >
                        <Trans chiave="Lezioni e Articoli" />
                      </button>
                    ) : null}
                    {strumenti.length ? (
                      <button
                        type="button"
                        className="autore-summary__link"
                        onClick={() => scrollToRef(ref.strumentiSlider)}
                      >
                        <Trans chiave="Materiali" />
                      </button>
                    ) : null}
                    {raccolte.length ? (
                      <button
                        type="button"
                        className="autore-summary__link"
                        onClick={() => scrollToRef(ref.raccolteSlider)}
                      >
                        <Trans chiave="Raccolte" />
                      </button>
                    ) : null}
                  </div>
                ) : null}
                {autore.biografia && <div className="autore-summary__bio">{autore.biografia}</div>}
              </>
            )}
          </div>
        </div>
        {!autore.redazionale && (
          <div className="autore-summary__links">
            {articoli.length ? (
              <button
                type="button"
                className="autore-summary__link"
                onClick={() => scrollToRef(ref.articoliSlider)}
              >
                <Trans chiave="Lezioni e Articoli" />
              </button>
            ) : null}
            {strumenti.length ? (
              <button
                type="button"
                className="autore-summary__link"
                onClick={() => scrollToRef(ref.strumentiSlider)}
              >
                <Trans chiave="Materiali" />
              </button>
            ) : null}
            {raccolte.length ? (
              <button
                type="button"
                className="autore-summary__link"
                onClick={() => scrollToRef(ref.raccolteSlider)}
              >
                <Trans chiave="Raccolte" />
              </button>
            ) : null}
          </div>
        )}
      </div>
    )
  })
)

export default AutoreSummary
